import React from 'react';
import { cn } from '@/lib/utils';

function CustomBox({ children, className, ...props }: React.ComponentProps<'div'>): React.JSX.Element {
    return (
        <div className={cn('p-6 pb-4', className)} {...props}>
            {children}
        </div>
    );
}

export default CustomBox;
